import type { IconName } from "./suite";

// Square-cut stroke icons, 24px grid, to match the industrial mark.
const PATHS: Record<IconName | "search" | "menu" | "plus" | "home" | "chev" | "close" | "ext", string> = {
  quality: "M12 3l8 3v6c0 4.4-3.4 7.8-8 9-4.6-1.2-8-4.6-8-9V6l8-3z M8.5 12l2.5 2.5 4.5-5",
  docs: "M6 3h9l4 4v14H6z M15 3v4h4 M9 12h7 M9 16h7",
  supply: "M3 7h11v9H3z M14 10h4l3 3v3h-7 M7 19.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z M17 19.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
  engineering: "M4 20l5-5 M14 4l6 6-9 9-6-6z M12 6l6 6",
  production: "M3 21V10l6 4V10l6 4V6h6v15z M7 17h2 M12 17h2 M17 17h2",
  maintenance: "M14.5 5.5a4 4 0 0 0-5 5L4 16l4 4 5.5-5.5a4 4 0 0 0 5-5l-2.5 2.5-3-.5-.5-3z",
  commercial: "M4 19V9 M10 19V5 M16 19v-7 M22 19H2",
  safety: "M12 3l10 18H2z M12 10v5 M12 17.5v.5",
  insights: "M4 20V4 M4 20h16 M8 16v-4 M12 16V8 M16 16v-6",
  admin: "M4 6h10 M18 6h2 M4 12h4 M12 12h8 M4 18h12 M20 18h0 M14 4v4 M8 10v4 M16 16v4",
  inventory: "M3 8l9-5 9 5v10l-9 5-9-5z M3 8l9 5 9-5 M12 13v10",
  training: "M2 9l10-5 10 5-10 5z M6 11v5c3 2.5 9 2.5 12 0v-5 M22 9v6",
  improve: "M4 20L10 14l4 4 6-8 M15 10h5v5",
  factory: "M4 12a8 8 0 0 1 14-5.3 M18 3v4h-4 M20 12a8 8 0 0 1-14 5.3 M6 21v-4h4",
  requests: "M5 3h14v18H5z M9 8h6 M9 12h6 M9 16l2 2 4-4",
  finance: "M3 6h18v12H3z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M6 9v6 M18 9v6",
  people: "M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z M2 20c0-3.5 3-6 7-6s7 2.5 7 6 M16 4.5a3.5 3.5 0 0 1 0 6.5 M18 14c2.4.7 4 2.9 4 6",
  it: "M3 4h18v12H3z M8 20h8 M12 16v4",
  productivity: "M3 4h18v16H3z M3 9h18 M3 14h18 M9 4v16",
  marketing: "M3 10v4h4l8 5V5l-8 5z M18 9.5a3.5 3.5 0 0 1 0 5 M20.5 7a7 7 0 0 1 0 10",
  workplace: "M4 21V5l8-3 8 3v16z M9 21v-4h6v4 M8 8h2 M14 8h2 M8 12h2 M14 12h2",
  ext: "M14 4h6v6 M20 4l-9 9 M18 14v6H4V6h6",
  search: "M10.5 17a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13z M15.5 15.5L21 21",
  menu: "M3 6h18 M3 12h18 M3 18h18",
  plus: "M12 5v14 M5 12h14",
  home: "M3 11l9-7 9 7 M5 10v10h14V10",
  chev: "M9 6l6 6-6 6",
  close: "M6 6l12 12 M18 6L6 18",
};

export function Icon({ name, size = 18, className }: { name: keyof typeof PATHS; size?: number; className?: string }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="square" strokeLinejoin="miter" aria-hidden="true">
      <path d={PATHS[name]} />
    </svg>
  );
}
